/* Floodlight · ss-contact.js (content)
   Contact page: topic → quantity field + message hint, client validation before the
   Shopify contact form posts, personalised success view. Port of parts/25-views.js vContact
   and parts/20-logic-core.js submit(). The form always posts through {% form 'contact' %}. */
(function () {
  if (window.SS_LOADED_contact) return;
  window.SS_LOADED_contact = true;

  var KEY = 'ss-contact-sent';

  function ready(type, init) {
    if (window.SS && typeof SS.sectionReady === 'function') return SS.sectionReady(type, init);
    var run = function () {
      Array.prototype.forEach.call(document.querySelectorAll('[data-section-type="' + type + '"]'), function (el) { init(el); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
  }

  function fill(tpl, map) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }

  function personalise(root) {
    var box = root.querySelector('[data-sent]');
    if (!box) return;
    var data = null;
    try { data = JSON.parse(sessionStorage.getItem(KEY) || 'null'); sessionStorage.removeItem(KEY); } catch (e) {}
    if (data) {
      var title = box.querySelector('[data-sent-title]');
      var text = box.querySelector('[data-sent-text]');
      if (title && data.first && box.dataset.titleNamed) title.textContent = fill(box.dataset.titleNamed, { first_name: data.first });
      if (text && data.phone && box.dataset.textNamed) text.textContent = fill(box.dataset.textNamed, { number: data.phone });
    }
    try { box.focus({ preventScroll: true }); } catch (e) {}
  }

  function init(root) {
    if (!root || root.__ssContact) return;
    root.__ssContact = true;
    personalise(root);

    var form = root.querySelector('form[data-contact-form]') || root.querySelector('form');
    if (!form || !form.querySelector('[data-field]')) return function () { root.__ssContact = false; };

    var topic = form.querySelector('[data-topic]');
    var qtyField = form.querySelector('[data-qty-field]');
    var msg = form.querySelector('[data-field="msg"]');

    function field(name) { return form.querySelector('[data-field="' + name + '"]'); }

    function setError(input, bad) {
      if (!input) return;
      var err = document.getElementById(input.id + '-err');
      input.classList.toggle('bad', bad);
      if (bad) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
      if (!err) return;
      err.hidden = !bad;
      // the error is only described while it is visible
      var ids = (input.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (x) { return x && x !== err.id; });
      if (bad) ids.push(err.id);
      if (ids.length) input.setAttribute('aria-describedby', ids.join(' '));
      else input.removeAttribute('aria-describedby');
    }

    function syncTopic() {
      if (!topic) return;
      var opt = topic.options[topic.selectedIndex];
      if (!opt) return;
      var askQty = opt.getAttribute('data-qty') === 'true';
      if (qtyField) {
        qtyField.hidden = !askQty;
        var q = qtyField.querySelector('input');
        if (q) q.disabled = !askQty;
      }
      if (msg && opt.getAttribute('data-hint')) msg.setAttribute('placeholder', opt.getAttribute('data-hint'));
      if (window.SS && typeof SS.emit === 'function') SS.emit('wa:check', {});
    }

    function check(name) {
      var el = field(name);
      if (!el) return true;
      var v = (el.value || '').trim();
      var ok = true;
      if (name === 'name') ok = v.length > 0;
      else if (name === 'phone') ok = v.replace(/\D/g, '').length >= 10;
      else if (name === 'email') ok = v.length > 0 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
      else if (name === 'msg') ok = v.length >= 2;
      return ok;
    }

    var names = ['name', 'phone', 'email', 'msg'];

    function onSubmit(e) {
      var first = null;
      names.forEach(function (n) {
        var ok = check(n);
        setError(field(n), !ok);
        if (!ok && !first) first = field(n);
      });
      if (first) {
        e.preventDefault();
        try { first.focus(); } catch (err) {}
        if (window.SS && typeof SS.emit === 'function') SS.emit('wa:check', {});
        return;
      }
      try {
        var nm = (field('name').value || '').trim().split(/\s+/)[0];
        var ph = (field('phone').value || '').trim();
        sessionStorage.setItem(KEY, JSON.stringify({ first: nm, phone: ph }));
      } catch (err) {}
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('aria-busy', 'true');
    }

    function onInput(e) {
      var n = e.target && e.target.getAttribute ? e.target.getAttribute('data-field') : null;
      if (n && e.target.classList.contains('bad') && check(n)) setError(e.target, false);
    }

    function onBlur(e) {
      var n = e.target && e.target.getAttribute ? e.target.getAttribute('data-field') : null;
      if (n && e.target.classList.contains('bad')) setError(e.target, !check(n));
    }

    form.addEventListener('submit', onSubmit);
    form.addEventListener('input', onInput);
    form.addEventListener('focusout', onBlur);
    if (topic) topic.addEventListener('change', syncTopic);
    syncTopic();

    return function destroy() {
      form.removeEventListener('submit', onSubmit);
      form.removeEventListener('input', onInput);
      form.removeEventListener('focusout', onBlur);
      if (topic) topic.removeEventListener('change', syncTopic);
      root.__ssContact = false;
    };
  }

  ready('page-contact', init);
})();
